import React from 'react';
import CovidDaily from './CovidDaily';
import Empty from './Empty';
import Success from './Success';
import List from './List';
import ListItem from './ListItem';
import Privacy from './Privacy';
import {
  BrowserRouter as Router,
  Switch,
  Route,
} from "react-router-dom";
function App() {
    return (
      <Router>
          <Switch>
            <Route exact path="/covid-daily">
              <CovidDaily />
            </Route>
              <Route exact path="/empty">
                  <Empty />
              </Route>
              <Route exact path="/success">
                  <Success />
              </Route>
              <Route exact path="/list">
                  <List />
              </Route>
                <Route exact path="/covid-daily-list">
                  <List />
              </Route>
              <Route component={ListItem}  path="/list-item"/>
              <Route component={Privacy}  path="/privacy"/>
          </Switch>
      </Router>
    );
}

export default App;
